// GHG Inventory Template Generator

export function downloadGHGInventoryTemplate() {
  const templateContent = `Greenhouse Gas Inventory Template
Generated from www.greenhousegascalculator.com

INSTRUCTIONS:
- Fill in the yellow highlighted cells with your data
- Annual emissions will be calculated automatically when opened in Excel
- Keep this template for year-over-year comparison
- Consult the methodology section for emission factor sources

,,,,
COMPANY INFORMATION,,,,
Company Name:,[Enter Company Name],,,
Reporting Period:,[Enter Year],,,
Industry:,[Enter Industry],,,
Contact:,[Enter Contact],,,
Date Completed:,[Enter Date],,,
,,,,
,,,,
SCOPE 1 EMISSIONS - DIRECT EMISSIONS,,,,
Category,Activity Data,Unit,Emission Factor,Annual Emissions (tons CO2e)
,,,,
STATIONARY COMBUSTION,,,,
Natural Gas,[Enter value],therms/year,0.0053,=B13*D13
Fuel Oil,[Enter value],gallons/year,0.0102,=B14*D14
Propane,[Enter value],gallons/year,0.0057,=B15*D15
Coal,[Enter value],tons/year,2.07,=B16*D16
,,,,
MOBILE COMBUSTION,,,,
Gasoline Vehicles - Fleet,[Enter number of vehicles],vehicles,4.6,=B19*D19
Diesel Vehicles - Fleet,[Enter number of vehicles],vehicles,5.2,=B20*D20
Average Miles per Vehicle per Year,[Enter value],miles/vehicle/year,0.000404,=B21*D21
,,,,
PROCESS EMISSIONS,,,,
Refrigerant Leaks (R-410A),[Enter value],kg/year,2.088,=B24*D24
Refrigerant Leaks (R-134a),[Enter value],kg/year,1.43,=B25*D25
Other Process Emissions,[Enter value],kg CO2e/year,0.001,=B26*D26
,,,,
FUGITIVE EMISSIONS,,,,
Wastewater Treatment,[Enter value],kg CH4/year,0.025,=B29*D29
Landfill Gas,[Enter value],m³ CH4/year,0.67,=B30*D30
,,,,
SCOPE 1 TOTAL,,,,=SUM(E13:E30)
,,,,
,,,,
SCOPE 2 EMISSIONS - INDIRECT EMISSIONS FROM PURCHASED ENERGY,,,,
Category,Activity Data,Unit,Emission Factor,Annual Emissions (tons CO2e)
,,,,
PURCHASED ELECTRICITY,,,,
Electricity Usage,[Enter value],kWh/year,0.00092,=B39*D39
Renewable Energy Credits,[Enter value],kWh/year,-0.00092,=B40*D40
,,,,
PURCHASED HEAT/STEAM/COOLING,,,,
District Heating,[Enter value],MMBtu/year,0.066,=B43*D43
District Cooling,[Enter value],MMBtu/year,0.016,=B44*D44
Purchased Steam,[Enter value],lbs/year,0.00008,=B45*D45
,,,,
SCOPE 2 TOTAL,,,,=SUM(E39:E45)
,,,,
,,,,
TOTAL SCOPE 1 + SCOPE 2 EMISSIONS,,,,=E32+E47
,,,,
,,,,
EMISSIONS INTENSITY METRICS,,,,
Metric,Value,Unit,,
Total Employees,[Enter value],employees,,
Emissions per Employee,=E49/B53,tons CO2e/employee,,
Total Revenue,[Enter value],USD,,
Emissions per Revenue,=E49/B55,tons CO2e/$1M revenue,,
Total Square Footage,[Enter value],sq ft,,
Emissions per Square Foot,=E49/B57,tons CO2e/sq ft,,
,,,,
,,,,
REDUCTION TARGETS,,,,
Target,Value,Unit,Target Year,
Baseline Year Emissions,[Enter value],tons CO2e,[Enter year],
Reduction Target,[Enter percentage],%,[Enter year],
Target Emissions,=B64*(1-B65/100),tons CO2e,,
Current Progress,=(B64-E49)/B64*100,%,,
,,,,
,,,,
NOTES AND ASSUMPTIONS,,,,
[Add any relevant notes about data sources or assumptions],,,,
,,,,
,,,,
EMISSION FACTORS REFERENCE,,,,
Source: EPA Greenhouse Gas Equivalencies Calculator,,,,
Source: GHG Protocol Emission Factors,,,,
Source: U.S. Energy Information Administration,,,,
,,,,
For detailed methodology visit: www.greenhousegascalculator.com/methodology,,,,`;

  // Create blob and download
  const blob = new Blob([templateContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `GHG-Inventory-Template-${new Date().getFullYear()}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
}

export function downloadBlankInventoryWorksheet() {
  const worksheetContent = `Annual Greenhouse Gas Inventory Worksheet

COMPANY: ________________________________     YEAR: __________

SCOPE 1 - DIRECT EMISSIONS

1. MOBILE COMBUSTION
   Number of Vehicles: __________
   Total Annual Mileage: __________
   Fuel Type (Gasoline/Diesel): __________
   
2. STATIONARY COMBUSTION
   Natural Gas (therms/year): __________
   Heating Oil (gallons/year): __________
   Propane (gallons/year): __________
   
3. REFRIGERANTS & PROCESS EMISSIONS
   Refrigerant Type: __________
   Leakage Amount (kg): __________
   

SCOPE 2 - INDIRECT EMISSIONS

1. PURCHASED ELECTRICITY
   Total kWh per Year: __________
   Renewable Energy %: __________
   
2. PURCHASED HEAT/STEAM
   District Heating (MMBtu): __________
   Steam Usage (kg): __________
   

CALCULATION SUMMARY

Scope 1 Total: __________ tons CO2e
Scope 2 Total: __________ tons CO2e
Total Emissions: __________ tons CO2e

Notes:
_____________________________________________________________
_____________________________________________________________
_____________________________________________________________

Calculate your emissions online: www.greenhousegascalculator.com
`;

  const blob = new Blob([worksheetContent], { type: 'text/plain;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `GHG-Inventory-Worksheet-${new Date().getFullYear()}.txt`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
}
